/**
 * Centralized date-handling utilities.
 * Eliminates duplication of `new Date().toISOString()` across the codebase.
 */

const END_OF_DAY_HOURS = 23;
const END_OF_DAY_MINUTES = 59;
const END_OF_DAY_SECONDS = 59;
const END_OF_DAY_MS = 999;
const DATE_SLICE_LENGTH = 10;

/**
 * Gets the current date/time in ISO string format.
 * Replaces the repeated pattern: `new Date().toISOString()`
 */
export function nowISO(): string {
  return new Date().toISOString();
}

/**
 * Gets the end of the current day (23:59:59.999) in ISO string format.
 */
export function endOfTodayISO(): string {
  const d = new Date();
  d.setHours(END_OF_DAY_HOURS, END_OF_DAY_MINUTES, END_OF_DAY_SECONDS, END_OF_DAY_MS);
  return d.toISOString();
}

/**
 * Gets only the date part (YYYY-MM-DD) of the current date.
 */
export function todayDateKey(): string {
  return new Date().toISOString().slice(0, DATE_SLICE_LENGTH);
}
